













































    import { Component, Vue, Watch ,Prop} from 'vue-property-decorator';
    import 'animate.css';
    import $ from 'jquery';
    @Component(
        {
            components:{
            }
        }
    )
    export default class equipMentPannel extends Vue {
        async mounted () {
            $('.itema').mouseenter((e)=>{
                $(`.itema`).removeClass("active");
            })
        }
 
        
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/components/equipMent.vue